<template>
  <div class="col-12 list-containernopads">
    <div v-if="lastModified" class="row hint-text px-3">
      {{ $t('contractor_reports.modified') }} : {{ toLocalTime(lastModified) }}
    </div>
    <div v-if="tableData.length > 0" class="list-content result-table">
        <vue3-datatable
            ref="resultTable"
            :rows="tableData"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="tableData.length > 10 ? '85vh' : '100%'"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >
        </vue3-datatable>
    </div>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'CertificateTable',
    mixins: [restApi, timeUtils],
    components: {Vue3Datatable},
    props: {
        users: {
            type: Array
        },
        certificates: {
            type: Array
        }
    },
    data: function () {
        return {
            fields: [],
            tableData: [],
            lastModified: ''
        }
    },
    watch: {
        certificates: function () {
            this.initializeData()
            this.initializeFields()
        }
    },
    mounted() {
        this.initializeData()
        this.initializeFields()
    },
    methods: {
        initializeFields() {
            this.fields = [];
            this.fields.push(
                { field: 'name', title: this.$t('contractor_reports.person_name'), sort: false,headerClass: 'routa-table-header' },
                { field: 'email', title: this.$t('users.email'), sort: false, headerClass: 'routa-table-header'},
                { field: 'phone', title: this.$t('users.phone'), sort: false, headerClass: 'routa-table-header'},
            )
            const that = this;
            this.certificates.forEach(item => {
                const field = `cert_id_${item.id}`
                this.fields.push({
                    field,
                    title: item.name,
                    sort: false,
                    headerClass: 'routa-table-header',
                    width: '7em',
                    cellRenderer: (item) => {
                        let cellClass = 'cell-container'
                        if (item._cellVariants[field]) {
                            cellClass += ' ' + item._cellVariants[field]
                        }
                        return '<div class="'+cellClass+'">' + item[field] + '</div>'
                     }
                });
            })
        },
        initializeData() {
            this.tableData = []
            const temp = []
            let latestEntry, latestEntryStr
            this.users.forEach(person => {
                let tableRow = []
                let cellVariants = {}
                tableRow['name'] = person.last_name + ', ' + person.first_name
                tableRow['email'] = person.email
                tableRow['phone'] = person.phone
                // Check which certificates the user has from all the available
                this.certificates.forEach(item => {
                    const certField = `cert_id_${item.id}`
                    let existingCertificates = person.certificates.filter(cert => cert.type.id === item.id)
                    let certificateValid = existingCertificates.find(existingCertificate =>
                        existingCertificate.granted_day && (!existingCertificate.expiration_day || !this.isInPast(existingCertificate.expiration_day))
                    )
                    let certificatePlanned = existingCertificates.find(existingCertificate => existingCertificate.planned && !existingCertificate.granted_day)

                    // Text shown in column
                    let value = ''
                    if(certificateValid) {
                        value = certificateValid.expiration_day ? this.getShortDateString(certificateValid.expiration_day) : 'Ok'
                    } else if (certificatePlanned) {
                        value = this.$t('certificate.certificate_planned')
                    } else {
                        // Get the latest expiration date for cert
                        const latestCertificate = existingCertificates.reduce((a, b) => {
                            // Skip invalid entries
                            if (!b.expiration_day) return a;
                            if (!a.expiration_day) return b;
                            return new Date(a.expiration_day) > new Date(b.expiration_day) ? a : b;
                        }, {});
                        value = latestCertificate.expiration_day ?  this.getShortDateString(latestCertificate.expiration_day) : ''
                    }
                    tableRow[certField] = value

                    // Variant color
                    if (certificateValid) {
                        cellVariants[certField] = 'cell-success'
                    } else if (certificatePlanned && this.withinYear(certificatePlanned.planned_date)) {
                        cellVariants[certField] = 'cell-warning'
                    } else {
                        cellVariants[certField] = 'cell-danger'
                    }
                    const lastMod = existingCertificates.reduce((a, b) => {
                        // Skip invalid entries
                        if (!b.last_modified) return a;
                        if (!a.last_modified) return b;
                        return new Date(a.last_modified) > new Date(b.last_modified) ? a : b;
                    }, {});
                    const lastModDate = new Date(lastMod.last_modified)
                    if (!latestEntry || lastModDate.getTime() > latestEntry.getTime()) {
                        latestEntry = lastModDate
                        latestEntryStr = lastMod.last_modified
                    }
                })
                tableRow['_cellVariants'] = cellVariants
                temp.push(tableRow)
            })
            this.lastModified = latestEntryStr? latestEntryStr : ''
            this.$nextTick(() => this.tableData = temp)
        }
    },

}
</script>
